function NoMatch () {
  return (
    <div>
      <h2>Nothing to see here!</h2>
    </div>
  )
}

export default NoMatch
